import {guideQueryOptions} from '@blesk-frontend/api';
import {createFileRoute} from '@tanstack/react-router';
import {GuideDetailPage} from '@/features/guides';

export const Route = createFileRoute('/_app/guides/$guideId/')({
  validateSearch: (search: {
    export?: boolean;
    discountId?: string;
    collectionId?: string;
    new?: boolean;
  }) => {
    return search;
  },
  beforeLoad: ({context: {queryClient}, params: {guideId}}) => ({
    getTitle: () => {
      const guide = queryClient.getQueryData(guideQueryOptions(guideId).queryKey);
      return guide?.name || 'Инструкция';
    },
  }),
  component: () => <GuideDetailPage />,
});
